import styled from "styled-components";

export const Corpo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  min-width: 0;

  .resumo{ font-size: 12px; color: #4D4F50; }
  .feedback{
    padding: 8px 10px;
    border-radius: 6px;
    font-size: 12px;
    background: #F1F8F2;
    border: 1px solid #CFE6D3;
    color: #1f7a33;
  }
  .erro-lista{ font-size: 12px; color: #C43333; }

  .more{
    color: var(--primary-color);
    width: 100%;
    display: flex;
    justify-content: center;
    cursor: pointer;
    background: transparent;
    border: none;
    margin: 4px 0 0;
    font-size: 14px;
    &:hover{ font-weight: bold; }
  }

  /* ---- células da tabela ---- */
  .nome{ font-weight: 600; font-size: 14px; overflow-wrap: anywhere; }
  .meta{ font-size: 11px; color: #4D4F50; overflow-wrap: anywhere; }
  .atuacao{ font-size: 13px; font-weight: 600; }

  /* Pedido de apoiador: miniatura do perfil + nome/contatos lado a lado. */
  .solicitante-linha{ display: flex; align-items: center; gap: 10px; min-width: 0; }
  .solicitante-linha > div:last-child{ min-width: 0; }
  .miniatura-perfil{ flex-shrink: 0; width: 40px; height: 40px; border: 1px solid var(--primary-color); }

  .link{ font-size: 12px; color: var(--primary-color); overflow-wrap: anywhere; }

  .mensagem{
    margin: 0;
    font-size: 12px;
    line-height: 150%;
    white-space: pre-wrap;
    overflow-wrap: anywhere;

    &.curta{
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .ver-mais{
    width: auto;
    height: auto;
    margin: 2px 0 0 !important;
    padding: 0;
    border: none;
    background: transparent;
    color: var(--primary-color);
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
    text-align: left;
  }

  .datas{ font-size: 12px; line-height: 150%; margin-top: 8px; }
  .datas > div + div{ margin-top: 6px; }
  .datas b{ display: block; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; color: #6B6E70; }

  .selo{
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 600;
    border: 1px solid transparent;

    &.Pendente{ background: #FFF7E5; color: #8A5A00; border-color: #F0DBA8; }
    &.Aprovada{ background: #E4F4E7; color: #1f7a33; border-color: #BFE0C5; }
    &.Recusada{ background: #FDF3F3; color: #A12A2A; border-color: #F0CACA; }
    &.Desabilitado{ background: #EFEFEF; color: #4D4F50; border-color: #D6D6D6; margin-left: 6px; }
  }

  .resposta{
    margin: 6px 0 0;
    font-size: 11px;
    color: #4D4F50;
    overflow-wrap: anywhere;
  }

  .acoes{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;

    button{
      width: auto;
      height: 28px;
      margin: 0 !important;
      padding: 0 12px;
      font-size: 11px;
      border-radius: 4px;
      cursor: pointer;
      background: var(--primary-color);
      color: #fff;
      border: none;
    }
    .secundario{
      background: transparent;
      color: #C43333;
      border: 1.2px solid #C43333;
    }

    /* "Cadastrar banner": mesmo tamanho dos botões, mas é um link de navegação. */
    a.atalho{
      display: inline-flex;
      align-items: center;
      height: 28px;
      padding: 0 12px;
      border-radius: 4px;
      background: var(--primary-color);
      color: #fff;
      font-size: 11px;
      font-weight: 600;
      text-decoration: none;
      &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
    }
  }

  .atalho-feedback{ margin-left: 6px; color: #1f7a33; font-weight: 700; text-decoration: underline; }

  .sem-acao{ font-size: 12px; color: #6B6E70; }

  .vazio{ padding: 28px 0; text-align: center; font-size: 13px; color: #4D4F50; }
`;

export const Fundo = styled.div`
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, .45);
`;

export const Dialogo = styled.div`
  width: min(520px, 100%);
  max-height: 90vh;
  overflow-y: auto;
  padding: 22px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, .25);

  h3{ margin: 0 0 6px; font-size: 18px; }
  .aviso{ margin: 0 0 12px; font-size: 13px; color: #4D4F50; }
  label{ display: block; margin: 0 0 4px; font-size: 12px; font-weight: 700; }
  textarea{ width: 100%; min-height: 90px; resize: vertical; font-family: inherit; font-size: 13px; padding: 8px; border: 1px solid #ccc; border-radius: 8px; box-sizing: border-box; }
  .erro{ display: block; margin-top: 6px; color: #C43333; font-size: 12px; }

  .botoes{
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;

    button{
      width: auto;
      height: 34px;
      margin: 0 !important;
      padding: 0 16px;
      font-size: 13px;
      border-radius: 6px;
      cursor: pointer;
      background: var(--primary-color);
      color: #fff;
      border: none;
    }
    .cancelar{ background: transparent; color: #4D4F50; border: 1px solid #DDDFE3; }
    .recusar{ background: #C43333; }
  }
`;
